<script type="text/javascript">
let isMobile = false;
if ((navigator.userAgent.match(/(phone|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
    isMobile = true;
}

let formatDate = (date) => {
    let newDate = new Date(date.replace(/-/g, '/'));
    return newDate.getFullYear() + '-' + numToString(newDate.getMonth() + 1) + '-'
        + numToString(newDate.getDate());
};

let formatTime = (date) => {
    let newDate = new Date(date.replace(/-/g, '/'));
    return newDate.getHours() + ':' + numToString(newDate.getMinutes());
};

let numToString = (number) => {
    return number >= 10 ? number.toString() : '0' + number; 
};

export default {
    isMobile,
    formatDate,
    formatTime,
    numToString
};
</script>